import { render, staticRenderFns } from "./IbEditDateButton.vue?vue&type=template&id=ca7d1d0e&scoped=true"
import script from "./IbEditDateButton.vue?vue&type=script&lang=js"
export * from "./IbEditDateButton.vue?vue&type=script&lang=js"
import style0 from "./IbEditDateButton.vue?vue&type=style&index=0&id=ca7d1d0e&prod&lang=less"
import style1 from "./IbEditDateButton.vue?vue&type=style&index=1&id=ca7d1d0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d1d0e",
  null
  
)

export default component.exports